export default __webpack_public_path__ + "static/media/allow-withdraw-1-ios.aa4b13ec.png";